import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import { formatViews, getCategoryName, getLatestChapter } from "@/utils/manga";

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const latest = getLatestChapter(comic);

  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} 韩漫在线阅读`}
          title={`${comic.title} 无删减韩漫`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/60 to-transparent"></div>
        <span className="absolute left-2 top-2 px-2 py-0.5 rounded-full text-[11px] font-medium bg-primary-500/90 text-background-50">
          {getCategoryName(comic.category)}
        </span>
        {comic.isNew && (
          <span className="absolute right-2 top-2 px-2 py-0.5 rounded-full text-[11px] font-medium bg-accent-500 text-white">
            新作
          </span>
        )}
        <span className="absolute right-2 bottom-2 flex items-center gap-1 text-[11px] text-white">
          <i className="ri-star-fill text-accent-400"></i>
          {comic.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-col gap-2 p-3">
        <div>
          <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 line-clamp-1 group-hover:text-accent-600 transition-colors">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-400 line-clamp-1 mt-0.5">
            {comic.subTitle}
          </p>
        </div>
        <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed h-8">
          {comic.description}
        </p>
        <div className="flex items-center justify-between text-[11px] text-foreground-500 pt-2 border-t border-background-200">
          <span className="line-clamp-1">
            {comic.status === "完结" ? "已完结" : `更新至 ${latest ? latest.title : ""}`}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {formatViews(comic.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}